/**
 * Object for creating click-triggered navigation submenus
 *
 * Based on:
 * - https://codepen.io/mrwweb/pen/pXqKZO
 * - https://css-tricks.com/in-praise-of-the-unambiguous-click-menu/
 */

(function () {
	"use strict";

	class ClickyMenus {
		constructor(menuSelector) {
			let menus = document.querySelectorAll(menuSelector),
				openMenusByContainer = {},
				openMenus = [],
				i,
				len;

			this.init = function () {
				menus.forEach(function (menu) {
					if (menu.innerHTML.includes("data-toggled-by")) {
						menuSetup(menu);
					}
				});

				document.addEventListener("click", closeOpenMenus);
			};

			/*===================================================
			=            Menu Open / Close Functions            =
			===================================================*/
			function toggleOnMenuClick(event) {
				let button = event.currentTarget;
				let submenu = getButtonSubmenu(button);
				let container = getButtonMenuContainer(button);

				// Close any other open flyouts, but leave the ancestor chain of the
				// just-clicked button alone — otherwise opening a nested flyout would
				// also close the parent flyout that contains it.
				openMenus.forEach(function (openButtonID) {
					let openButton = document.getElementById(openButtonID);
					let openSubmenu = getButtonSubmenu(openButton);
					let containsClickedButton = openSubmenu && openSubmenu.contains(button);
					if (
						button.getAttribute("id") !== openButton.getAttribute("id") &&
						!containsClickedButton &&
						menuIsAbsolutelyPositioned(openButton)
					) {
						toggleSubmenu(openButton);
					}
				});

				// let openSubmenus = container.querySelectorAll("[aria-expanded='true']");
				// openSubmenus.forEach(function (openButton) {
				// 	if (button.getAttribute("id") !== openButton.getAttribute("id")) {
				// 		toggleSubmenu(openButton);
				// 	}
				// });

				toggleSubmenu(button);
			}

			function toggleSubmenu(button) {
				// console.log("Toggling " + button.getAttribute("id"));
				let expanded = button.getAttribute("aria-expanded");
				let submenu = getButtonSubmenu(button);
				let container = getButtonMenuContainer(button);

				if (expanded === "true") {
					button.setAttribute("aria-expanded", false);
					submenu.setAttribute("aria-hidden", true);
					makeElementsFocusable(submenu.focusableElements, true);

					if (openMenus.includes(button.id)) {
						let submenuIndex = openMenus.findIndex((id) => id === button.id);
						openMenus.splice(submenuIndex, 1);
					}
				} else {
					button.setAttribute("aria-expanded", true);
					submenu.setAttribute("aria-hidden", false);
					makeElementsFocusable(submenu.focusableElements, false);
					closeOnFocusOut(button);

					if (!openMenus.includes(button.id)) {
						openMenus.push(button.id);
					}
				}
			}

			function menuIsAbsolutelyPositioned(button) {
				let submenu = getButtonSubmenu(button);

				if (window.getComputedStyle(submenu).position === "absolute") {
					return true;
				}

				return false;
			}

			function closeOnFocusOut(button) {
				document.addEventListener("focusin", (event) => {
					// Use DOM containment so a focusin on a deeply-nested
					// descendant (e.g. a level-3 leaf link inside this
					// button's level-2 submenu, inside this button's
					// level-1 submenu) is still treated as "inside" the
					// ancestor chain. getClosestButton only finds the
					// nearest enclosing toggle, which collapses the outer
					// menus mid-click and prevents link navigation.
					let submenu = getButtonSubmenu(button);
					if (
						submenu &&
						!submenu.contains(event.target) &&
						button.getAttribute("aria-expanded") === "true" &&
						menuIsAbsolutelyPositioned(button)
					) {
						toggleSubmenu(button);
					}
				});
			}

			function closeOnEscKey(event) {
				if (27 === event.keyCode) {
					if ("true" === event.target.getAttribute("aria-expanded")) {
						// we're on a parent item
						toggleSubmenu(event.target);
					} else {
						// we're probably in a submenu item
						let button = getClosestButton(event.target);
						if (null !== button) {
							button.focus();
							toggleSubmenu(button);
						}
					}
				}
			}

			function closeOpenMenus(event) {
				let button = event.target.closest("[aria-expanded]");
				if (null !== button) {
				} else {
					openMenus.forEach((button_id) => {
						let button = document.getElementById(button_id);
						if (menuIsAbsolutelyPositioned(button)) {
							toggleSubmenu(button);
						}
					});
				}
			}

			/*===========================================================
			=            Modify Menu Markup & Bind Listeners            =
			=============================================================*/
			function menuSetup(menu) {
				openMenusByContainer[menu.id] = [];
				menu.querySelectorAll("[data-toggled-by]").forEach(function (submenu) {
					if ("undefined" !== typeof submenu) {
						const menuItem = submenu.parentElement;

						let buttonId;
						buttonId = submenu.getAttribute("data-toggled-by");

						let button = menuItem.querySelector("#" + buttonId);

						if (button !== null && button.matches("a, span")) {
							button = convertElementToButton(button);
						} else {
							return;
						}

						setUpAria(submenu, button);

						// set child item focus
						submenu.focusableElements = getFocusableElements(submenu);
						makeElementsFocusable(submenu.focusableElements, false);

						// bind event listener to button
						button.addEventListener("click", toggleOnMenuClick);
						menu.addEventListener("keydown", closeOnEscKey);
					}
				});
			}

			function setUpAria(submenu, button) {
				const menuItemId = submenu.getAttribute("data-toggled-by");
				const submenuId = submenu.getAttribute("id");
				const expandedByDefault = submenu.getAttribute("data-aria-expanded-default");

				let id;
				if (null === submenuId) {
					id = button.textContent.trim().replace(/\s+/g, "-").toLowerCase() + "-submenu";
				} else {
					id = menuItemId;
				}

				let expanded;
				if (null === expandedByDefault) {
					expanded = false;
				} else {
					expanded = true;
				}

				// set button ARIA
				button.setAttribute("aria-controls", submenuId);
				button.setAttribute("aria-expanded", expanded);

				// set submenu ARIA
				submenu.setAttribute("aria-hidden", !expanded);

				// remove setup attributes for cleaner markup
				submenu.removeAttribute("data-aria-expanded-default");
			}

			/*===========================================================
			=                     Utility Functions                     =
			=============================================================*/
			function getClosestButton(element) {
				let navList = element.closest("[data-toggled-by][aria-hidden='false']");
				if (null !== navList) {
					let buttonID = navList.getAttribute("data-toggled-by");
					return document.getElementById(buttonID);
				}

				return false;
			}

			function getButtonSubmenu(button) {
				return document.getElementById(button.getAttribute("aria-controls"));
			}
			function getButtonMenuContainer(button) {
				return button.closest("[data-nav-dropdowns]");
			}

			/**
			 * Get make elements focusable
			 * @source ?
			 * @param  {NodeList} elements the group of elements
			 * @param  {Boolean} focusable whether they should be made focusable or not
			 * @return {Boolean}
			 */
			function makeElementsFocusable(elements, focusable) {
				elements.forEach(function (element) {
					if (focusable === false) {
						element.removeAttribute("tabindex");
					} else {
						element.setAttribute("tabindex", "-1");
					}
				});
			}

			/**
			 * Get focusable elements within a container
			 * @source Andy Bell?
			 * @param  {Element} parent The HTML Element
			 * @return {Boolean}
			 */
			function getFocusableElements(parent) {
				if (!parent) {
					console.warn("You need to pass a parent HTMLElement");
					return [];
				}

				return parent.querySelectorAll(
					'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
				);
			}

			/**
			 * Convert an HTML element to a button
			 * @url https://justmarkup.com/articles/2019-01-21-the-link-to-button-enhancement/
			 * @param  {Element} element The HTML Element
			 * @return {Boolean}
			 */
			function convertElementToButton(element) {
				if (null !== element) {
					const elementHTML = element.innerHTML;
					const elementAtts = element.attributes;
					const button = document.createElement("button");

					// copy button attributes and content from link
					button.innerHTML = elementHTML.trim();
					for (i = 0, len = elementAtts.length; i < len; i++) {
						let attr = elementAtts[i];
						if ("href" !== attr.name) {
							button.setAttribute(attr.name, attr.value);
						}
					}
					element.replaceWith(button);

					return button;
				}

				return element;
			}
		}
	}

	/* Create a ClickMenus object and initiate menu for any menu containing "aria-control" */
	document.addEventListener("DOMContentLoaded", function () {
		let clickyMenus = new ClickyMenus("[data-nav-dropdowns]");
		clickyMenus.init();
	});
})();
